//App
import { ClaimDto } from "../app/model/api/types/dto";

export class ClaimViewModel {
  id?: string | null;
  name: string | null;
  description: string | null;
  claimTypeId: Array<string> | null;
  sortValue: number | null;
  isActive: boolean | null;

  constructor(
    id: string | null,
    name: string | null,
    description: string | null,
    claimTypeId: Array<string> | null,
    sortValue: number | null,
    isActive: boolean | null
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.claimTypeId = claimTypeId;
    this.sortValue = sortValue;
    this.isActive = isActive;
  }

  toDto(): ClaimDto {
    return {
      id: this.id,
      isActive: this.isActive,
      name: this.name,
      description: this.description,
      claimTypeId:
        this.claimTypeId !== null && this.claimTypeId?.length > 0
          ? this.claimTypeId[0]
          : null,
      sortValue: Number(this.sortValue),
    };
  }

  mapFromDto(dto: ClaimDto): void {
    this.id = dto.id;
    this.isActive = dto.isActive || true;
    this.name = dto.name;
    this.description = dto.description;
    dto.claimTypeId !== null
      ? this.claimTypeId?.push(dto.claimTypeId)
      : (this.claimTypeId = null);
    this.sortValue = dto.sortValue;
  }
}
